var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-row',{staticClass:"member-progress-viewer-graphic w-full h-full",class:_vm.graphicPosition},[_c('vs-col',{attrs:{"vs-w":_vm.graphicSize}},[_c('img',{attrs:{"src":_vm.graphicSrc,"alt":_vm.graphicAlt}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }